import { triggerState, handleChange } from '../config'
const states = {
  n_areaId: 0, //区域
  s_appId: '', //应用
  n_deviceId: 0, //设备
  s_picSize: 'small', //展示图的大小
  n_areaIndex: 0,
  o_rootData: {}
}
export default {
  namespaced: true,
  state: handleChange({ states, namespace: 'visualize' }),
  mutations: {
    changeArea(state, payload) {
      triggerState({
        state,
        property: 'n_areaId',
        payload,
        namespace: 'visualize'
      })
      this.commit('visualize/smallPicSize')
    },
    changeApp(state, payload) {
      triggerState({
        state,
        property: 's_appId',
        payload,
        namespace: 'visualize'
      })
    },
    changeDevice(state, payload) {
      triggerState({
        state,
        property: 'n_deviceId',
        payload,
        namespace: 'visualize'
      })
    },
    changeRootData(state, payload) {
      triggerState({
        state,
        property: 'o_rootData',
        payload,
        namespace: 'visualize'
      })
    },
    changeAreaIndex(state, payload) {
      triggerState({
        state,
        property: 'n_areaIndex',
        payload,
        namespace: 'visualize'
      })
    },
    smallPicSize(state) {
      triggerState({
        state,
        property: 's_picSize',
        payload: 'small',
        namespace: 'visualize'
      })
    },
    togglePicSize(state) {
      if (state.s_picSize == 'small') {
        triggerState({
          state,
          property: 's_picSize',
          payload: 'big',
          namespace: 'visualize'
        })
      } else {
        triggerState({
          state,
          property: 's_picSize',
          payload: 'small',
          namespace: 'visualize'
        })
      }
    }
  },
  actions: {},
  getters: {
    a_expand(state) {
      return [state.n_areaId]
    },
    o_curArea(state) {
      if (!state.o_rootData.areas || state.o_rootData.areas.length == 0) {
        return state.o_rootData
      } else {
        return state.o_rootData.areas[state.n_areaIndex]
      }
    },
    s_areaName(state, getters) {
      return getters.o_curArea.name
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/visualize.js